import { Checkbox, Typography } from '@mui/joy';

import { Color, Level } from 'theme/enums';

interface IProps {
  isDefault: boolean;
  defaultLabel: string;
  makeDefaultLabel: string;
  onMakeDefault?: () => void;
}

export const DefaultCheckbox = ({
  isDefault,
  defaultLabel,
  makeDefaultLabel,
  onMakeDefault,
}: IProps) => {
  const label = (
    <Typography level={Level.BODY_SM} color={isDefault ? Color.SUCCESS : Color.NEUTRAL}>
      {isDefault ? defaultLabel : makeDefaultLabel}
    </Typography>
  );

  return (
    <Checkbox
      color={isDefault ? Color.SUCCESS : Color.NEUTRAL}
      checked={isDefault}
      disabled={!onMakeDefault}
      label={label}
      onChange={isDefault ? undefined : onMakeDefault}
      sx={{ paddingTop: 1 }}
    />
  );
};
